import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'
import { signOut } from 'store/auth'
import ROUTES from 'constants/routes'

export default function UserHome() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { logout } = useAuth0()

  const handleSignOut = () => {
    dispatch(signOut())
    logout({ logoutParams: { returnTo: window.location.origin + ROUTES.APP_URL_LOGIN } })
  }

  return (
    <div className="user-home">
      <h1 className="user-home__title">{t('userHome.title')}</h1>
      <p className="user-home__message">{t('userHome.message')}</p>
      <button type="button" className="primary-button" onClick={handleSignOut}>
        {t('logout.button')}
      </button>
    </div>
  )
}
